import React, { useCallback, useEffect, useState } from 'react'

import { useAppDispatch } from '@/hooks/redux'
import { useAppSelector } from '@/store'
import { setStumpShadeRecipeOutput } from '@/store/fullLayering'

import StumpShadeTooltip from './components/StumpShadeTooltip'

const KonvaFLStumpShade = () => {
  const dispatch = useAppDispatch()
  const targetColor = useAppSelector(
    (state) => state.fullLayering.stumpShadeTargetColor,
  )
  const preparationColor = useAppSelector(
    (state) => state.fullLayering.stumpShadePreparationColor,
  )
  const stumpShadeOutput = useAppSelector(
    (state) => state.fullLayering.stumpShadeRecipeOutput,
  )

  const canvasImage = useAppSelector((state) => state.app.canvasImage)

  const [tooltipOpenMap, setTooltipOpenMap] = useState<Record<string, boolean>>(
    {},
  )

  useEffect(() => {
    const initialTooltipState: Record<string, boolean> = {}

    const targetKeys = Object.keys(targetColor?.[canvasImage?.id] || {})
    if (targetKeys.length) {
      targetKeys.forEach((key) => {
        initialTooltipState[`target_${key.toLowerCase()}`] = true
      })
    }

    const preparationKeys = Object.keys(
      preparationColor?.[canvasImage?.id] || {},
    )
    if (preparationKeys.length) {
      preparationKeys.forEach((key) => {
        initialTooltipState[`preparation_${key.toLowerCase()}`] = true
      })
    }

    setTooltipOpenMap(initialTooltipState)
  }, [targetColor, preparationColor, canvasImage?.id])

  const handleToggleTooltip = useCallback((key: string) => {
    setTooltipOpenMap((prev) => ({ ...prev, [key]: !prev[key] }))
  }, [])

  const handleCloseTooltip = useCallback((key: string) => {
    setTooltipOpenMap((prev) => ({ ...prev, [key]: false }))
  }, [])

  const handleDeleteStumpShade = useCallback(
    (regionKey: string) => {
      if (!canvasImage?.id) return

      dispatch(
        setStumpShadeRecipeOutput({
          imageId: canvasImage?.id,
          key: regionKey,
          result: undefined,
        }),
      )

      const [prefix, pureKey] = regionKey.split('_')

      if (prefix === 'target') {
        dispatch({
          type: 'fullLayering/removeStumpShadeTargetColor',
          payload: {
            imageId: canvasImage?.id,
            key: pureKey.toUpperCase(),
          },
        })
      } else if (prefix === 'preparation') {
        dispatch({
          type: 'fullLayering/removeStumpShadePreparationColor',
          payload: {
            imageId: canvasImage?.id,
            key: pureKey.toUpperCase(),
          },
        })
      }
    },
    [dispatch, canvasImage?.id],
  )
  return (
    <>
      {Object.keys(targetColor?.[canvasImage?.id] || {}).map((key) => {
        const data = targetColor?.[canvasImage?.id]?.[key]
        const output =
          stumpShadeOutput?.[canvasImage?.id]?.[`target_${key.toLowerCase()}`]

        if (!output) return null
        return (
          <StumpShadeTooltip
            key={`target_${key}`}
            keyName={`target_${key.toLowerCase()}`}
            data={data}
            output={output}
            open={!!tooltipOpenMap[`target_${key.toLowerCase()}`]}
            toggle={handleToggleTooltip}
            close={handleCloseTooltip}
            keyData={key}
            onDelete={handleDeleteStumpShade}
          />
        )
      })}

      {Object.keys(preparationColor?.[canvasImage?.id] || {}).map((key) => {
        const data = preparationColor?.[canvasImage?.id]?.[key]
        const output =
          stumpShadeOutput?.[canvasImage?.id]?.[
            `preparation_${key.toLowerCase()}`
          ]

        if (!output) return null

        return (
          <StumpShadeTooltip
            key={`preparation_${key}`}
            keyName={`preparation_${key.toLowerCase()}`}
            data={data}
            output={output}
            open={!!tooltipOpenMap[`preparation_${key.toLowerCase()}`]}
            toggle={handleToggleTooltip}
            close={handleCloseTooltip}
            keyData={key}
            onDelete={handleDeleteStumpShade}
          />
        )
      })}
    </>
  )
}

export default KonvaFLStumpShade
